/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Facet properties that can be used for sorting. Default value is 'propertyName'.
 *
 */
export var FacetPropertiesForSorting;
(function (FacetPropertiesForSorting) {
    FacetPropertiesForSorting["PROPERTY_NAME"] = "propertyName";
    FacetPropertiesForSorting["PROPERTY_LABEL"] = "propertyLabel";
    FacetPropertiesForSorting["COUNT"] = "count";
})(FacetPropertiesForSorting || (FacetPropertiesForSorting = {}));
